<template>
    <section class="service-use" id="service-use">
        <div class="container" v-intersect>
            <h2 class="title text-xl">이용하기</h2>
            <ul class="service-list">
                <li>
                    <strong class="service-name">복지시설 회원가입</strong>
                    <p class="desc">
                        복지시설 별 계정을 만든 후<br>
                        관리자용 홈페이지 및 바로돌봄 앱<br>
                        이용이 가능합니다.
                    </p>
                    <a href="https://partner.soldoc.co.kr/home?type=b2b" target="_blank" title="새 창" class="btn-link">
                        <span class="sr-only">바로가기</span>
                    </a>
                </li>
                <li>
                    <strong class="service-name">관리자 페이지</strong>
                    <p class="desc">
                        환자 프로필 관리, 진료 내역 조회,<br>
                        영수증 조회 등 기관 관리자를 위한<br>
                        홈페이지입니다.
                    </p>
                    <a href="https://admin.soldoc.co.kr/" target="_blank" title="새 창" class="btn-link">
                        <span class="sr-only">바로가기</span>
                    </a>
                </li>
                <li>
                    <strong class="service-name">앱 다운로드</strong>
                    <p class="desc">
                        바로돌봄 앱을 통해 간편하게<br>
                        영상으로 진료를 보고<br>
                        이용내역을 확인할 수 있습니다.
                    </p>
                    <a href="https://play.google.com/store/apps/details?id=com.soldocbarocare" target="_blank" title="새 창" class="btn-link">
                        <span class="sr-only">바로가기</span>
                    </a>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ServiceUse',  
    directives: {
        intersect: {
            // 요소가 DOM에 삽입될 때 호출됩니다.
            inserted(el) {
                const options = {
                    root: null, // 뷰포트를 기본값으로 설정
                    rootMargin: '0px', // 뷰포트의 마진은 0
                    threshold: 0.1 // 10%가 보일 때 콜백이 실행
                };
                const callback = (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            el.classList.add('visible');
                        } else {
                            el.classList.remove('visible');
                        }
                    });
                };
                const observer = new IntersectionObserver(callback, options);
                observer.observe(el); // 해당 요소를 관찰 시작
            }
        }
    },
}
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/pc_barocare_new/ServiceUse.vue